export default __webpack_public_path__ + "static/Fanpowered-Logo-Black-34e096c34a27f5cafa80782f0729bf12.png";